import { HomePasteTable, HomeGroupLayout } from 'components';
import React from 'react';

/**
 * 在這邊描述這個組件
 */

export const HomePastePage = () => {
  return (
    <HomeGroupLayout>
      <HomePasteTable />
    </HomeGroupLayout>
  );
};

